export default {
  categories: [],
};
